"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Wifi;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Wifi(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Facilities"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "wifi"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "outline",
    d: "M55.469,72.607a5.97,5.97,0,1,1-5.97-5.969A5.97,5.97,0,0,1,55.469,72.607ZM11.768,39.76a54.068,54.068,0,0,1,76.464,0,2.5,2.5,0,1,0,3.536-3.535,59.067,59.067,0,0,0-83.536,0,2.5,2.5,0,0,0,3.536,3.535ZM66.221,65.3a2.5,2.5,0,0,0,0-3.535,22.941,22.941,0,0,0-32.447,0A2.5,2.5,0,1,0,37.31,65.3a17.942,17.942,0,0,1,25.376,0,2.5,2.5,0,0,0,3.535,0ZM24.538,52.531a36.048,36.048,0,0,1,50.921,0A2.5,2.5,0,0,0,78.994,49,41.053,41.053,0,0,0,21,49a2.5,2.5,0,1,0,3.535,3.535Z"
  }))));
}